export enum TherapyTypes {
  PHYSICAL_THERAPY = 'physical-therapy',
  OCCUPATIONAL_THERAPY = 'occupational-therapy',
  SPEECH_THERAPY = 'speech-therapy',
  APPLIED_BEHAVIOR_ANALYSIS = 'applied-behavior-analysis',
  FEEDING_THERAPY = 'feeding-therapy',
  MUSIC_THERAPY = 'music-therapy',
  ART_THERAPY = 'art-therapy',
  DANCE_MOVEMENT_THERAPY = 'dance-movement-therapy',
  EQUINE_THERAPY = 'equine-therapy',
  RECREATIONAL_THERAPY = 'recreational-therapy',
  AROMATHERAPY = 'aromatherapy',
  MASSAGE_THERAPY = 'massage-therapy',
  CHIROPRACTIC_THERAPY = 'chiropractic-therapy',
  RADIATION_THERAPY = 'radiation-therapy',
  CHEMOTHERAPY = 'chemotherapy',
  CHEST_PHYSIOTHERAPY = 'chest-physiotherapy-cpt',
  COGNITIVE_BEHAVIORAL_THERAPY = 'cognitive-behavioral-therapy-cbt',
  HORMONE_REPLACEMENT_THERAPY = 'hormone-replacement-therapy-hrt',
  HORMONE_THERAPY = 'hormone-therapy-for-gender-transition',
  PHYSICAL_MEDICINE_REHABILITATION = 'physical-medicine-and-rehabilitation-pm-r',
  RESPIRATORY_THERAPY = 'respiratory-therapy',
  CARDIAC_REHABILITATION = 'cardiac-rehabilitation',
  BEHAVIORAL_THERAPY = 'behavioral-therapy',
  DIALECTICAL_BEHAVIORAL_THERAPY = 'dialectical-behavioral-therapy-dbt',
  EQUINE_ASSISTED_THERAPY = 'equine-assisted-therapy',
  FAMILY_THERAPY = 'family-therapy',
  COUPLES_THERAPY = 'couples-therapy',
  GROUP_THERAPY = 'group-therapy',
  AQUATIC_THERAPY = 'aquatic-therapy'
}

export const THERAPY_TYPES_AND_CODES: Record<TherapyTypes, { label: string; code: string }> = {
  [TherapyTypes.PHYSICAL_THERAPY]: {
    label: 'Physical Therapy (PT)',
    code: 'PT'
  },
  [TherapyTypes.OCCUPATIONAL_THERAPY]: {
    label: 'Occupational Therapy (OT)',
    code: 'OT'
  },
  [TherapyTypes.SPEECH_THERAPY]: {
    label: 'Speech Therapy (ST)',
    code: 'ST'
  },
  [TherapyTypes.APPLIED_BEHAVIOR_ANALYSIS]: {
    label: 'Applied Behavior Analysis (ABA)',
    code: 'ABA'
  },
  [TherapyTypes.FEEDING_THERAPY]: {
    label: 'Feeding Therapy',
    code: 'FeedingTherapy'
  },
  [TherapyTypes.MUSIC_THERAPY]: {
    label: 'Music Therapy',
    code: 'MusicTherapy'
  },
  [TherapyTypes.ART_THERAPY]: {
    label: 'Art Therapy',
    code: 'ArtTherapy'
  },
  [TherapyTypes.DANCE_MOVEMENT_THERAPY]: {
    label: 'Dance/Movement Therapy',
    code: 'DanceMovementTherapy'
  },
  [TherapyTypes.EQUINE_THERAPY]: {
    label: 'Equine Therapy',
    code: 'EquineTherapy'
  },
  [TherapyTypes.RECREATIONAL_THERAPY]: {
    label: 'Recreational Therapy',
    code: 'RecreationalTherapy'
  },
  [TherapyTypes.AROMATHERAPY]: {
    label: 'Aromatherapy',
    code: 'Aromatherapy'
  },
  [TherapyTypes.MASSAGE_THERAPY]: {
    label: 'Massage Therapy',
    code: 'MassageTherapy'
  },
  [TherapyTypes.CHIROPRACTIC_THERAPY]: {
    label: 'Chiropractic Therapy',
    code: 'ChiropracticTherapy'
  },
  [TherapyTypes.RADIATION_THERAPY]: {
    label: 'Radiation Therapy',
    code: 'RadiationTherapy'
  },
  [TherapyTypes.CHEMOTHERAPY]: {
    label: 'Chemotherapy',
    code: 'Chemotherapy'
  },
  [TherapyTypes.CHEST_PHYSIOTHERAPY]: {
    label: 'Chest Physiotherapy (CPT)',
    code: 'CPT'
  },
  [TherapyTypes.COGNITIVE_BEHAVIORAL_THERAPY]: {
    label: 'Cognitive Behavioral Therapy (CBT)',
    code: 'CBT'
  },
  [TherapyTypes.HORMONE_REPLACEMENT_THERAPY]: {
    label: 'Hormone Replacement Therapy (HRT)',
    code: 'HRT'
  },
  [TherapyTypes.HORMONE_THERAPY]: {
    label: 'Hormone Therapy (for gender transition)',
    code: 'HormoneTherapy'
  },
  [TherapyTypes.PHYSICAL_MEDICINE_REHABILITATION]: {
    label: 'Physical Medicine and Rehabilitation (PM&R)',
    code: 'PMR'
  },
  [TherapyTypes.RESPIRATORY_THERAPY]: {
    label: 'Respiratory Therapy',
    code: 'RespiratoryTherapy'
  },
  [TherapyTypes.CARDIAC_REHABILITATION]: {
    label: 'Cardiac Rehabilitation',
    code: 'CardiacRehabilitation'
  },
  [TherapyTypes.BEHAVIORAL_THERAPY]: {
    label: 'Behavioral Therapy',
    code: 'BehavioralTherapy'
  },
  [TherapyTypes.DIALECTICAL_BEHAVIORAL_THERAPY]: {
    label: 'Dialectical Behavioral Therapy (DBT)',
    code: 'DBT'
  },
  [TherapyTypes.EQUINE_ASSISTED_THERAPY]: {
    label: 'Equine-Assisted Therapy',
    code: 'EquineAssistedTherapy'
  },
  [TherapyTypes.FAMILY_THERAPY]: {
    label: 'Family Therapy',
    code: 'FamilyTherapy'
  },
  [TherapyTypes.COUPLES_THERAPY]: {
    label: 'Couples Therapy',
    code: 'CouplesTherapy'
  },
  [TherapyTypes.GROUP_THERAPY]: {
    label: 'Group Therapy',
    code: 'GroupTherapy'
  },
  [TherapyTypes.AQUATIC_THERAPY]: {
    label: 'Aquatic Therapy',
    code: 'AquaticTherapy'
  }
}
